import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnAlternative, BtnPrimary } from "../../share/buttons/Btn";
import { useForm } from "react-hook-form";
import Inputs from "../../share/input/Inputs";
import { Step } from "@material-ui/core";

const ShebaConfirmModal = ({ close, step, setStep }) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  return (
    <div className="relative">
      <button
        onClick={() => {
          close(false);
          setStep(0);
        }}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className="text-center text-[#77498F] mb-16">تسویه حساب</h3>
      <div className="flex flex-row gap-32 my-20">
        <div className="flex flex-col font-bold text-[1.5rem]">
          <p className="pb-10">نام درخواست کننده:</p>
          <p className="pb-10">شبا:</p>
          <p className="pb-10">شماره کارت:</p>
          <p className="">بانک:</p>
        </div>
        <div className="flex flex-col text-[1.5rem]">
          <p className="pb-10">علی رجبی</p>
          <p className="pb-10">IR-0315-00000000000000-1234599</p>
          <p className="pb-10">1515-1414-1313-1212</p>
          <p>بانک ملی ایران</p>
        </div>
      </div>
      <div className="flex flex-row gap-8 items-center justify-end">
        <BtnAlternative
          className="py-[2rem] px-[4rem] flex mr-auto"
          text="مرحله قبل"
          onClick={() => setStep(step - 1)}
        />
        <BtnPrimary
          className="py-[2rem] px-[4rem] flex"
          text="تایید و تسویه حساب"
          onClick={() => setStep(step + 1)}
        />
      </div>
    </div>
  );
};

export default ShebaConfirmModal;
